/**
 * Converts the given entry to a string safely.
 * If the entry is null, undefined, or does not have a valid toString method, returns an empty string.
 * @param entry The entry to convert to a string.
 * @returns The string representation of the entry or an empty string.
 */
export function safeToString<X>(entry: X | null | undefined): string {
  if (
    entry &&
    typeof entry === "object" &&
    "toString" in entry &&
    typeof (entry as { toString: unknown }).toString === "function"
  ) {
    return (entry as { toString: () => string }).toString();
  }
  return "";
}